import { render, staticRenderFns } from "./LearnMoreOld.vue?vue&type=template&id=7f21babc"
import script from "./LearnMoreOld.vue?vue&type=script&lang=js"
export * from "./LearnMoreOld.vue?vue&type=script&lang=js"
import style0 from "./LearnMoreOld.vue?vue&type=style&index=0&id=7f21babc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports